/**
 * Ensures a URL has the https:// prefix
 * @param url The URL to check and possibly modify
 * @returns The URL with https:// prefix if it didn't have one already
 */
export const ensureHttpsPrefix = (url: string): string => {
    if (!url) return url;
    return url.match(/^https?:\/\//) ? url : `https://${url}`;
};
